<template>
  <div class="passenger-seg-list">
    <template v-for="(passenger, index) in passegnersArray">
      <passenger-box
        :passenger="passenger"
        :key="index"
        :index="index"
        :order="order"
        :cmsData="cmsData"
        v-bind="$attrs"
        v-on="$listeners"
        @select="selectHandler"
      >
      </passenger-box>
    </template>
  </div>
</template>

<script>
import { queryBenefit } from '@/apis/order'

import PassengerBox from './module/PassengerBox.vue'
import _ from 'lodash'

import './css/PassengerSegList.less'

export default {
  name: 'l8-passenger-seg-list',
  props: {
    passengers: {
      type: Array,
      default: function () {
        return []
      }
    },
    order: {
      type: Object
    }
  },
  watch: {
    passengers: function () {
      let copyPass = JSON.parse(JSON.stringify(this.passengers))

      _.each(copyPass, (pass) => {
        _.each(pass.flightSegments, (seg) => {
          seg.checked = false
        })
      })
      this.passegnersArray = copyPass

      let allSegs = []

      _.each(this.passegnersArray, (traveler) => {
        if (traveler.infantTravelers && traveler.infantTravelers.length) {
          _.each(traveler.infantTravelers, (infant) => {
            _.each(infant.flightSegments, (infantSeg) => {
              infantSeg.passengerType = infant.type
              allSegs.push(infantSeg)
            })
          })
        }

        _.each(traveler.flightSegments, (seg) => {
          seg.passengerType = traveler.type
          allSegs.push(seg)
        })
      })

      this.allSegs = allSegs
    },
    allSegs: function (newValue) {
      if (newValue && newValue.length) {
        this.fetchBenefit()
        // const benefits = []
        // for (let index = 0; index < newValue.length; index++) {
        //   benefits.push(newValue[index].benefit)
        // }
        // this.updateBenefit(benefits)
      }
    }
  },
  data () {
    return {
      allSegs: [],
      selectedPass: [],
      selectedSeg: [],
      passegnersArray: [],
      cmsData: {}
    }
  },
  created () {
    let copyPass = JSON.parse(JSON.stringify(this.passengers))

    _.each(copyPass, (pass) => {
      _.each(pass.flightSegments, (seg) => {
        seg.checked = false
      })
    })
    this.passegnersArray = copyPass
    this.getCmsData()
  },
  methods: {
    async getCmsData () {
      try {
        await window.__MICRO_ROOT__?.cms?.getPageData().then(res => {
          const { passengerInfTips, refundChangeRuleTip } = res
          this.cmsData = {
            passengerInfTips: passengerInfTips?.content || '',
            refundChangeRuleTips: refundChangeRuleTip?.content || ''
          }
        })
      } catch (err) {}
    },
    fetchBenefit () {
      const { order, allSegs } = this

      let products = _.map(allSegs, (seg) => {
        const fares = []
        fares.push({
          passengerType: seg.passengerType,
          netFare: Number(seg.netFare),
          basePrice: Number(seg.baseFare)
        })
        const data = {
          'arrCode': seg.arrivalCode,
          'cabinCode': seg.cabinCode,
          'refCabinCode': seg.rcabinCode,
          'depCode': seg.departureCode,
          'flightDate': this.moment(seg.departureTime).format('YYYY-MM-DD'),
          'flightNo': seg.flightNo,
          'productCode': seg.productCode,
          'depDate': seg.departureTime,
          'arrDate': seg.arrivalTime,
          'bookTime': seg.bookDate ? seg.bookDate : this.moment(order.createTime).format('YYYY-MM-DD HH:mm:ss'),
          'fares': fares
        }

        return data
      })

      let params = {
        'airlineCode': allSegs[0].airlineCode,
        'products': products
      }

      queryBenefit(params).then((res) => {
        this.updateBenefit(res.benefits)
      }).catch((error) => {
        this.$message.error(error.message || '权益查询失败，请稍候重试。')
      })
    },
    updateBenefit (benefits) {
      _.each(this.allSegs, (seg) => {
        let target = _.filter(benefits, (benefit) => {
          return benefit.cabinCode === seg.cabinCode &&
          benefit.productCode === seg.productCode &&
          benefit.flightNo === seg.flightNo &&
          _.get(benefit, 'languageBenefitDetails[0].passengerType') &&
          benefit.languageBenefitDetails[0].passengerType === seg.passengerType
        })[0]

        if (target) {
          this.$set(seg, 'benefits', target)
        }
      })
    },
    selectHandler (passenger, seg, checked) {
      if (checked) {
        this.addPass(passenger)
        this.cacheSelectSeg(seg, passenger)
      } else {
        this.removePass(passenger)
        this.uncacheSelectSeg(seg)
      }

      this.$emit('select', passenger, seg, checked)
      this.$emit('change', this.selectedPass, this.selectedSeg)
    },
    addPass (pass) {
      this.selectedPass.push(pass)
    },
    removePass (pass) {
      let dup = null

      _.each(this.selectedPass, (_pass, passIndex) => {
        if (_pass.fullName === pass.fullName) {
          dup = passIndex
        }
      })

      if (dup !== null) {
        this.selectedPass.splice(dup, 1)
      }
    },
    // 选中的航段
    cacheSelectSeg (seg, pass) {
      let dup = _.filter(this.selectedSeg, (s) => {
        return s.id === seg.id
      })

      seg.passenger = _.omit(JSON.parse(JSON.stringify(pass)), ['flightSegments'])

      if (!dup.length) {
        this.selectedSeg.push(JSON.parse(JSON.stringify(seg)))
      }
    },
    // 取消选中的航段
    uncacheSelectSeg (seg) {
      let targetIndex = null
      _.each(this.selectedSeg, (s, idx) => {
        if (s.id === seg.id) {
          targetIndex = idx
        }
      })
      if (targetIndex !== null) {
        this.selectedSeg.splice(targetIndex, 1)
      }
    }
  },
  components: {
    PassengerBox: PassengerBox
  }
}
</script>
